import React, { useContext, useState } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { ModalServiceContext } from "./../../ricos-context/ModalContext.js";
import { useBiNext } from "./../../_shared/bi-context-provider/bi-context-provider.js";
import { PmNodeType } from "./../../_shared/pm-node-types.js";
import { useNodeAttrs } from "./../../_shared/use-node-attrs.js";
import { resolveColorsPalette } from "./../../wix-rich-content-common/index.js";
import { NewColorPicker } from "./../../ui-components/color-picker/new-color-picker/index.js";
const BorderColorPicker = ({
  modalId,
  nodeId,
  referenceElement,
  config,
  defaultColor,
  onColorSelected,
  onColorAdded: onColorAddedProp
}) => {
  const modalService = useContext(ModalServiceContext);
  const { t } = useContext(RicosContext);
  const { pmNodeAttrs } = useNodeAttrs(nodeId, PmNodeType.IMAGE);
  const logBi = useBiNext({
    modalId,
    pluginId: "image",
    nodeId
  });
  const themeColors = resolveColorsPalette(
    config?.colors ? Object.values(config?.colors) : [],
    void 0,
    57
  );
  const [customColors, setCustomColors] = useState(
    resolveColorsPalette(
      config.getBorderColors?.() ?? [],
      pmNodeAttrs?.styles?.border?.color ?? defaultColor,
      57
    )
  );
  const onColorAdded = (color) => {
    onColorAddedProp(color);
    setCustomColors((prev) => [...prev, color]);
    onColorSelected(color);
  };
  const closeModal = () => modalService.closeModal(modalId);
  const onResetColor = () => onColorSelected(void 0);
  const currentColor = pmNodeAttrs?.styles?.border?.color?.toUpperCase();
  return /* @__PURE__ */ React.createElement(
    NewColorPicker,
    {
      themeColors,
      customColors,
      currentColor,
      title: t("Colours"),
      closeModal,
      onColorSelected,
      onColorAdded,
      onResetColor,
      referenceElement,
      logBi
    }
  );
};
export {
  BorderColorPicker
};
//# sourceMappingURL=border-color-picker.js.map
